import {Routes} from '@angular/router';

import {passwordResetFinishRoute} from '@app/account/password-reset/finish/password-reset-finish.route';
import {passwordResetInitRoute} from '@app/account/password-reset/init/password-reset-init.route';

const ACCOUNT_ROUTES = [passwordResetFinishRoute, passwordResetInitRoute];

export const accountState: Routes = [
  {
    path: '',
    children: ACCOUNT_ROUTES,
  },
];
